import AlexandraCourtTwoBrMain from './img/alexandra-courts/bedroom/2bedroom.jpg';
import AlexandraCourtThreeBrMain from './img/alexandra-courts/bedroom/3bedroom.jpg';
import AlexandraCourtFourBrMain from './img/alexandra-courts/bedroom/4bedroom.png';

import RenewedHopeTwoBrMain from './img/renewed-hope-estate/2-bedroom/1.jpg';
import RenewedHopeThreeBrMain from './img/renewed-hope-estate/3-bedroom/1.jpg';
import RenewedHopeFourBrMain from './img/renewed-hope-estate/4-bedroom/1.png';

import AlaroCityMain from './img/Alaro-city/1.png';
import AlaroCityMain2 from './img/Alaro-city/2.png';
import AlaroCityCommercialMain from './img/Alaro-city/commercial/1.png';
import AlaroCityIndustrialMain from './img/Alaro-city/commercial/2.png';

import BromptonCityMain from './img/lands/brompton-city.jpeg';
import SangotedoCityMain from './img/lands/sangotedo.jpeg';

import DantataGardens from './img/dantata-gardens/5bd.png';
import DantataGardens3 from './img/dantata-gardens/4bsd.png';
import DantataGardens2 from './img/dantata-gardens/4btd.png';
import DantataGardens4 from './img/dantata-gardens/bofs.png';

import LakeBohan from './img/lake-bohan/5bsd.png';
import LakeBohan2 from './img/lake-bohan/4btd.png';
import LakeBohan3 from './img/lake-bohan/3bof.png';

import GrandLuvuTwoBr from './img/grand-luvu/1.jpeg';
import GrandLuvuTwoBrSD from './img/grand-luvu/1.jpeg';
import GrandLuvuOneBr from './img/grand-luvu/1.jpeg';

import Chisco from './img/Chisco/OKWH1.png';
import Modern from './img/Morden/OKWH7.png';
import Niyi from './img/Niyi/OKWH17.png';  
import Ologolo from './img/Ologolo/OKWH14.png';
import Paramount from './img/paramount/1.jpeg';



const properties = [
  {
    name: 'Paramount Towers',
    mainImage: Paramount,
    type: 'Premium 2 Bedroom flats',
    price: 680000000,
    location: 'Lekki/Oniru extension, Lagos',
    mortgageAvailable: 'True',
    description: [
      'Paramount Twin Towers offers luxurious premium 2-bedroom apartments in 13-floor towers at Oniru, Lagos, with stunning ocean and city views. Amenities include 24/7 security, electricity, gym, pool, playground, lounges, restaurants, a mini mall, and parking for 300+ cars.',
      'This prime property delivers both modern living and a smart investment, with early investors enjoying 40% capital appreciation.',
      'With a payment plan that allows you make 40% initial deposit and 10 months balance spread.',
      'Developed by Grenadines Homes and contracted by BCL Construction & Engineering, this prime property delivers both modern living and a smart investment, with early investors enjoying 40% capital appreciation.'
    ],
    otherImages: [],
  },
  {
    name: '4 bedroom terrace duplex',
    mainImage: Ologolo,
    type: '4 Bedroom Terrace Duplex with BQ',
    price: 160000000,
    location: 'Lekki, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'A stylish 4-Bedroom Semi-Detached Duplex with BQ in the prime area of Ologolo, Lekki.',
      'Features spacious rooms, modern finishes, a fully fitted kitchen, and a great location close to schools, malls, and business hubs.',
      'Discover elegance and comfort in this stunning Four-Bedroom Semi-Detached Duplex with BQ, perfectly located in the serene and highly sought-after area of Ologolo, Lekki, Lagos.',
      'Designed with modern architecture and premium finishes, this home offers spacious living areas, en-suite bedrooms, a fully fitted kitchen, ample parking, and a private backyard.',
      'Situated just minutes from Lekki’s top schools, malls, and business hubs, it’s the perfect blend of style, convenience, and investment value.',
      'Areas near Ologolo, Lekki include the well-known commercial hub of Chevron Drive, the recreational spot of the Lekki Conservation Centre, and the nearby well-developed neighborhoods of Agungi, Osapa London, and Lekki Phase 1.',
      'Other landmarks and areas within or close to Lekki include Ikate-Elegushi and the Circle Mall (Whitesand Beach Estate).',
    ],
    otherImages: [],
  },
  {
    name: 'Luxurious 4 bedroom terrace duplex',
    mainImage: Niyi,
    type: '4 Bedroom Terrace Duplex with BQ',
    price: 350000000,
    location: 'Ogudu GRA, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Luxurious 4-bedroom terrace duplex with BQ is designed with cutting-edge smart facilities from automated lighting and climate control to advanced security systems, all managed at your fingertips.',
      'Welcome to the charm and comfort of Ogudu GRA, a serene, secure, and well-planned community in the heart of Lagos.',
      'This Four-Bedroom Terrace Duplex with BQ offers you modern living in a neighborhood known for its clean environment, friendly atmosphere, and easy access to major parts of the city.',
      'Because where you live matters just as much as the home you live in.Step into a world of luxury with this breathtaking Four-Bedroom Terrace Duplex, complete with a BQ, nestled in the prestigious Ogudu GRA, Lagos.',
    ],
    otherImages: [],
  },
  {
    name: 'Modern City2 bedroom apartment',
    mainImage: Modern,
    type: '2 Bedroom Apartment',
    price: 12000000,
    location: 'Ikorodu, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'This Property Features 2 Bedrooms,Living Rooms,2 Bathrooms, Spacious Parking Space, 24/7 Water Supply.',
      'Located along Erunwen Road, Off Obafemi Awolowo Road, Itamaga, Ikorodu, Lagos, this beautifully built apartment complex offers a total of 1 and 2-Bedroom units designed for comfort, style, and modern living.',
      'With quality finishes, ample parking, and easy access to major roads, markets, and schools, it’s the perfect choice for both homeowners and investors seeking great rental returns.',
    ],
    otherImages: [],
  },
  {
    name: 'Modern City 1 bedroom apartment',
    mainImage: Modern,
    type: '1 Bedroom Apartment',
    price: 9000000,
    location: 'Ikorodu, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'This Property Features 1 Bedroom,Living Rooms,2 Bathrooms, Spacious Parking Space, 24/7 Water Supply.',
      'Located along Erunwen Road, Off Obafemi Awolowo Road, Itamaga, Ikorodu, Lagos, this beautifully built apartment complex offers a total of 1 and 2-Bedroom units designed for comfort, style, and modern living.',
      'With quality finishes, ample parking, and easy access to major roads, markets, and schools, it’s the perfect choice for both homeowners and investors seeking great rental returns.',
    ],
    otherImages: [],
  },
  {
    name: 'Luxurious Chisco 3 bedroom apartment',
    mainImage: Chisco,
    type: '3 Bedroom flats with Ensuite BQ',
    price: 150000000,
    location: 'Chisco, Lekki, Lagos state',
    mortgageAvailable: 'False',
    description: [
      '3 Bedrooms with ample room for relaxation and privacy, each bedroom offers natural light, cozy layouts and modern finishes.',
      'With Kitchen designed for comfort and style. Perfect for families or guests, featuring sleek fixtures, ample space and a touch of luxury.',
      'This home features spacious en-suite bedrooms, a fully fitted kitchen, ample parking, and quality finishes throughout.',
      'Its strategic location offers easy access to major roads, shopping malls, schools, and business hubs, making it perfect for both living and investment.',
    ],
    otherImages: [],
  },
  {
    name: 'Alexandra Courts',
    mainImage: AlexandraCourtTwoBrMain,
    type: '2 Bedroom Terrace with BQ',
    price: 0,
    location: 'Ibeju Lekki, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Nestled in the heart of Ibeju Lekki’s Coastal City Residential Scheme, Alexandra Courts Coastal City offers an unparalleled opportunity to live, work, and thrive in the region famously dubbed “The New Lagos.”',
      'Strategically positioned within the New Town Development Hub of the Lekki Peninsula, our estate is a masterpiece of modern design and functionality, featuring a blend of 2-bedroom and 3-bedroom flats, as well as semi-detached and fully detached duplexes.',
      'Every unit is thoughtfully crafted to deliver ultimate comfort and sophistication to our residents.',
    ],
    otherImages: [],
  },
  {
    name: 'Alexandra Courts',
    mainImage: AlexandraCourtThreeBrMain,
    type: '3 Bedroom Terrace with BQ',
    price: 70000000,
    location: 'Ibeju Lekki, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Nestled in the heart of Ibeju Lekki’s Coastal City Residential Scheme, Alexandra Courts Coastal City offers an unparalleled opportunity to live, work, and thrive in the region famously dubbed “The New Lagos.”',
      'Strategically positioned within the New Town Development Hub of the Lekki Peninsula, our estate is a masterpiece of modern design and functionality, featuring a blend of 2-bedroom and 3-bedroom flats, as well as semi-detached and fully detached duplexes.',
      'Every unit is thoughtfully crafted to deliver ultimate comfort and sophistication to our residents.',
    ],
    otherImages: [],
  },
  {
    name: 'Alexandra Courts',
    mainImage: AlexandraCourtFourBrMain,
    type: '4 Bedroom Manssionette with BQ',
    price: 85000000,
    location: 'Ibeju Lekki, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Nestled in the heart of Ibeju Lekki’s Coastal City Residential Scheme, Alexandra Courts Coastal City offers an unparalleled opportunity to live, work, and thrive in the region famously dubbed “The New Lagos.”',
      'Strategically positioned within the New Town Development Hub of the Lekki Peninsula, our estate is a masterpiece of modern design and functionality, featuring a blend of 2-bedroom and 3-bedroom flats, as well as semi-detached and fully detached duplexes.',
      'Every unit is thoughtfully crafted to deliver ultimate comfort and sophistication to our residents.',
    ],
    otherImages: [],
  },
  {
    name: 'Renewed Hope Estate',
    type: '2 Bedroom terrace',
    mainImage: RenewedHopeTwoBrMain,
    price: 36000000,
    location: 'Ibeju Lekki, Lagos state',
    mortgageAvailable: 'True',
    description: [
      'Strategically located in Ibeju Lekki and developed in partnership with the Federal Mortgage Bank of Nigeria, Renewed Hope City is nestled within the New Town Development Hub of the Lekki Peninsula, aptly known as “The New Lagos.”',
      'This estate features a perfect blend of 2-bedroom and 3-bedroom flats alongside terrace duplexes, all tastefully designed for ultimate comfort.',
      'With its proximity to major commercial hubs and key infrastructure, Renewed Hope City offers unmatched economic, residential, and commercial value, making it the ideal destination for modern living.',
    ],
    otherImages: [],
  },
  {
    name: 'Renewed Hope Estate',
    type: '3 Bedroom terrace',
    mainImage: RenewedHopeThreeBrMain,
    price: 48000000,
    location: 'Ibeju Lekki, Lagos state',
    mortgageAvailable: 'True',
    description: [
      'Strategically located in Ibeju Lekki and developed in partnership with the Federal Mortgage Bank of Nigeria, Renewed Hope City is nestled within the New Town Development Hub of the Lekki Peninsula, aptly known as “The New Lagos.”',
      'This estate features a perfect blend of 2-bedroom and 3-bedroom flats alongside terrace duplexes, all tastefully designed for ultimate comfort.',
      'With its proximity to major commercial hubs and key infrastructure, Renewed Hope City offers unmatched economic, residential, and commercial value, making it the ideal destination for modern living.',
    ],
    otherImages: [],
  },
  {
    name: 'Renewed Hope Estate',
    type: '4 Bedroom terrace duplex',
    mainImage: RenewedHopeFourBrMain,
    price: 85000000,
    location: 'Ibeju Lekki, Lagos state',
    mortgageAvailable: 'True',
    description: [
      'Strategically located in Ibeju Lekki and developed in partnership with the Federal Mortgage Bank of Nigeria, Renewed Hope City is nestled within the New Town Development Hub of the Lekki Peninsula, aptly known as “The New Lagos.”',
      'This estate features a perfect blend of 2-bedroom and 3-bedroom flats alongside terrace duplexes, all tastefully designed for ultimate comfort.',
      'With its proximity to major commercial hubs and key infrastructure, Renewed Hope City offers unmatched economic, residential, and commercial value, making it the ideal destination for modern living.',
    ],
    otherImages: [],
  },
  {
    name: 'Universal Homes',
    type: 'Apartments with Statndard View',
    mainImage: AlaroCityMain,
    price: 124000000,
    location: 'Lekki, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Nestled in the heart of Alaro City Lagos, Universal Homes is a thoughtfully designed, family-friendly, master-planned community that sets the standard for contemporary living.',
      'Featuring 576 two-bedroom apartments, with the flexibility to expand into three or four bedrooms, this serene enclave combines modern elegance with tranquil surroundings.',
      'Residents enjoy a perfect balance of world-class amenities, innovative design, and Alaro City’s unwavering commitment to sustainability, greenery, and nature, creating a truly exceptional living experience.',
    ],
    otherImages: [],
  },
  {
    name: 'Universal Homes',
    type: 'Apartments with Double Balcony View',
    mainImage: AlaroCityMain2,
    price: 142600000,
    location: 'Lekki, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Nestled in the heart of Alaro City Lagos, Universal Homes is a thoughtfully designed, family-friendly, master-planned community that sets the standard for contemporary living.',
      'Featuring 576 two-bedroom apartments, with the flexibility to expand into three or four bedrooms, this serene enclave combines modern elegance with tranquil surroundings.',
      'Residents enjoy a perfect balance of world-class amenities, innovative design, and Alaro City’s unwavering commitment to sustainability, greenery, and nature, creating a truly exceptional living experience.',
    ],
    otherImages: [],
  },
  {
    name: 'Universal City plots',
    type: 'Commercial Plots',
    mainImage: AlaroCityCommercialMain,
    price: 302303000,
    location: 'Lekki, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Strategically located along the newly expanded Lekki-Epe Expressway, Alaro City Commercial Plots offer unmatched proximity to critical infrastructure, including the Lekki Deep Sea Port, the upcoming New Lagos International Airport, and the 4th Mainland Bridge.',
      'These commercial plots provide unparalleled connectivity, positioning your business at the heart of a rapidly growing economic hub.',
      'With an impressive projected ROI of 64% in just five years, investing in Alaro City Commercial plots is a gateway to both strategic growth and substantial returns.',
    ],
    otherImages: [],
  },
  {
    name: 'Universal City plots',
    type: 'Industrial Plots',
    mainImage: AlaroCityIndustrialMain,
    price: 341060000,
    location: 'Lekki, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Located along the newly upgraded Lekki-Epe Expressway, Alaro City industrial plots offer seamless access to key infrastructure such as the Lekki Deep Sea Port, the upcoming New Lagos International Airport, and the 4th Mainland Bridge.',
      'These plots are strategically designed to cater to industrial growth within a thriving economic hub, delivering an outstanding projected ROI of 95% within 5 years.',
      'Invest in these Industrial plots and secure your place in a future of unparalleled opportunities.',
    ],
    otherImages: [],
  },
  {
    name: 'Brompton City plots',
    type: '300/400SQM Residential Plots',
    mainImage: BromptonCityMain,
    price: 88031100,
    location: 'Ogombo Road, Lekki Scheme II, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Located along the newly upgraded Lekki-Epe Expressway, Brompton City Residential plots offer seamless access to key infrastructure such as the Lekki Deep Sea Port, the upcoming New Lagos International Airport, and the 4th Mainland Bridge.',
      'These plots are strategically designed to cater to industrial growth within a thriving economic hub, delivering an outstanding projected ROI of 95% within 5 years.',
      'Invest in these Industrial plots and secure your place in a future of unparalleled opportunities.',
    ],
    otherImages: [],
  },
  {
    name: 'Brompton City plots',
    type: '550/600SQM Residential Plots',
    mainImage: BromptonCityMain,
    price: 167450800,
    location: 'Ogombo Road, Lekki Scheme II, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Located along the newly upgraded Lekki-Epe Expressway, Brompton City Residential plots offer seamless access to key infrastructure such as the Lekki Deep Sea Port, the upcoming New Lagos International Airport, and the 4th Mainland Bridge.',
      'These plots are strategically designed to cater to industrial growth within a thriving economic hub, delivering an outstanding projected ROI of 95% within 5 years.',
      'Invest in these Industrial plots and secure your place in a future of unparalleled opportunities.',
    ],
    otherImages: [],
  },
  {
    name: 'Brompton City plots',
    type: '900/1000SQM Residential Plots',
    mainImage: BromptonCityMain,
    price: 314397900,
    location: 'Ogombo Road, Lekki Scheme II, Lagos state',
    mortgageAvailable: 'False',
    description: [
      'Located along the newly upgraded Lekki-Epe Expressway, Brompton City Residential plots offer seamless access to key infrastructure such as the Lekki Deep Sea Port, the upcoming New Lagos International Airport, and the 4th Mainland Bridge.',
      'These plots are strategically designed to cater to industrial growth within a thriving economic hub, delivering an outstanding projected ROI of 95% within 5 years.',
      'Invest in these Industrial plots and secure your place in a future of unparalleled opportunities.',
    ],
    otherImages: [],
  },
  {
    name: 'Sangotedo City',
    type: '327.11SQM Residential Plots',
    mainImage: SangotedoCityMain,
    price: 67015350,
    location: 'Monastery Road, Sangotedo, Lekki, Lagos',
    mortgageAvailable: 'False',
    description: [
      'Located along the newly upgraded Lekki-Epe Expressway, Sangotedo City Residential plots offer seamless access to key infrastructure such as the Lekki Deep Sea Port, the upcoming New Lagos International Airport, and the 4th Mainland Bridge.',
      'These plots are strategically designed to cater to industrial growth within a thriving economic hub, delivering an outstanding projected ROI of 95% within 5 years.',
      'Invest in these Industrial plots and secure your place in a future of unparalleled opportunities.',
    ],
    otherImages: [],
  },
  {
    name: 'Dantata Gardens',
    type: '5 Bedroom Duplex Apartment',
    mainImage: DantataGardens,
    price: 99900000,
    location: 'Karsana, Abuja',
    mortgageAvailable: 'True',
    description: [
      'Dantata Gardens is a premium estate in the serene neighborhood of Karsana, Abuja, offering a range of exquisitely designed homes, including 5 and 4-bedroom fully detached duplexes, 4-bedroom semi-detached duplexes, and 1, 2, and 3-bedroom flats.',
      'Perfectly blending luxury and functionality, the estate features contemporary architecture, lush landscaping, round-the-clock security, and family-friendly amenities.',
      'Located just minutes from the city center, Dantata Gardens provides a peaceful retreat with easy access to major roads and essential services, making it the ideal choice for modern living.',
    ],
    otherImages: [],
  },
  {
    name: 'Dantata Gardens',
    type: '4 Bedroom Semi-Duplex Apartment',
    mainImage: DantataGardens2,
    price: 51100500,
    location: 'Karsana, Abuja',
    mortgageAvailable: 'True',
    description: [
      'Dantata Gardens is a premium estate in the serene neighborhood of Karsana, Abuja, offering a range of exquisitely designed homes, including 5 and 4-bedroom fully detached duplexes, 4-bedroom semi-detached duplexes, and 1, 2, and 3-bedroom flats.',
      'Perfectly blending luxury and functionality, the estate features contemporary architecture, lush landscaping, round-the-clock security, and family-friendly amenities.',
      'Located just minutes from the city center, Dantata Gardens provides a peaceful retreat with easy access to major roads and essential services, making it the ideal choice for modern living.',
    ],
    otherImages: [],
  },
  {
    name: 'Dantata Gardens',
    type: '4 Bed Terraced Duplex with BQ',
    mainImage: DantataGardens3,
    price: 46300500,
    location: 'Karsana, Abuja',
    mortgageAvailable: 'True',
    description: [
      'Dantata Gardens is a premium estate in the serene neighborhood of Karsana, Abuja, offering a range of exquisitely designed homes, including 5 and 4-bedroom fully detached duplexes, 4-bedroom semi-detached duplexes, and 1, 2, and 3-bedroom flats.',
      'Perfectly blending luxury and functionality, the estate features contemporary architecture, lush landscaping, round-the-clock security, and family-friendly amenities.',
      'Located just minutes from the city center, Dantata Gardens provides a peaceful retreat with easy access to major roads and essential services, making it the ideal choice for modern living.',
    ],
    otherImages: [],
  },
  {
    name: 'Dantata Gardens',
    type: '1,2,3 Bedroom Block of flats',
    mainImage: DantataGardens4,
    price: 46300500,
    location: 'Karsana, Abuja',
    mortgageAvailable: 'True',
    description: [
      'Dantata Gardens is a premium estate in the serene neighborhood of Karsana, Abuja, offering a range of exquisitely designed homes, including 5 and 4-bedroom fully detached duplexes, 4-bedroom semi-detached duplexes, and 1, 2, and 3-bedroom flats.',
      'Perfectly blending luxury and functionality, the estate features contemporary architecture, lush landscaping, round-the-clock security, and family-friendly amenities.',
      'Located just minutes from the city center, Dantata Gardens provides a peaceful retreat with easy access to major roads and essential services, making it the ideal choice for modern living.',
    ],
    otherImages: [],
  },
  {
    name: 'Lake Bohan Estate',
    type: '5 Bed Semi-detached Duplex',
    mainImage: LakeBohan,
    price: 80000000,
    location: 'Lokogoma, Abuja',
    mortgageAvailable: 'True',
    description: [
      'Nestled in the heart of Lokogoma, Abuja, Lake Bohen Estate offers a harmonious blend of elegance and comfort with its 5 and 4-bedroom semi-detached duplexes and stylish 3-bedroom flats.',
      'Designed for modern living, the estate features contemporary architecture, secure gated access, and serene surroundings, making it an ideal haven for families and professionals.',
      'With easy access to major roads, schools, and shopping centers, Lake Bohen Estate combines convenience and tranquility to provide the perfect living experience.',
    ],
    otherImages: [],
  },
  {
    name: 'Lake Bohan Estate',
    type: ' 4 Bedroom Terrace Duplex',
    mainImage: LakeBohan2,
    price: 70000000,
    location: 'Lokogoma, Abuja',
    mortgageAvailable: 'True',
    description: [
      'Nestled in the heart of Lokogoma, Abuja, Lake Bohen Estate offers a harmonious blend of elegance and comfort with its 5 and 4-bedroom semi-detached duplexes and stylish 3-bedroom flats.',
      'Designed for modern living, the estate features contemporary architecture, secure gated access, and serene surroundings, making it an ideal haven for families and professionals.',
      'With easy access to major roads, schools, and shopping centers, Lake Bohen Estate combines convenience and tranquility to provide the perfect living experience.',
    ],
    otherImages: [],
  },
  {
    name: 'Lake Bohan Estate',
    type: '3 Bedroom Block of flats',
    mainImage: LakeBohan3,
    price: 45000000,
    location: 'Lokogoma, Abuja',
    mortgageAvailable: 'True',
    description: [
      'Nestled in the heart of Lokogoma, Abuja, Lake Bohen Estate offers a harmonious blend of elegance and comfort with its 5 and 4-bedroom semi-detached duplexes and stylish 3-bedroom flats.',
      'Designed for modern living, the estate features contemporary architecture, secure gated access, and serene surroundings, making it an ideal haven for families and professionals.',
      'With easy access to major roads, schools, and shopping centers, Lake Bohen Estate combines convenience and tranquility to provide the perfect living experience.',
    ],
    otherImages: [],
  },
  {
    name: 'Grand Luvu Estate 3',
    type: '2-Bed Bungalow',
    mainImage: GrandLuvuTwoBr,
    price: 11000000,
    location: 'Masaka, Nassarawa',
    mortgageAvailable: 'True',
    description: [
      'Grand Luvu Estate is a premium residential community in Masaka, Nasarawa State, offering 1-bedroom and 2-bedroom expandable homes in semi-detached and fully detached designs.',
      'Just minutes from Abuja, the estate provides a secure, serene, and well-planned environment with 24/7 security, paved roads, and green spaces.',
      'Homes are available in carcass for customization or semi-finished for a move-in-ready experience, making it ideal for both homeowners and investors.',
      'Limited units available—contact us today to secure your home!',
    ],
    otherImages: [],
  },
  {
    name: 'Grand Luvu Estate 3',
    type: '2-Bed S/Detached Bungalow',
    mainImage: GrandLuvuTwoBrSD,
    price: 8500000,
    location: 'Masaka, Nassarawa',
    mortgageAvailable: 'True',
    description: [
      'Grand Luvu Estate is a premium residential community in Masaka, Nasarawa State, offering 1-bedroom and 2-bedroom expandable homes in semi-detached and fully detached designs.',
      'Just minutes from Abuja, the estate provides a secure, serene, and well-planned environment with 24/7 security, paved roads, and green spaces.',
      'Homes are available in carcass for customization or semi-finished for a move-in-ready experience, making it ideal for both homeowners and investors.',
      'Limited units available—contact us today to secure your home!',
    ],
    otherImages: [],
  },
  {
    name: 'Grand Luvu Estate 3',
    type: '1-Bed S/Detached Bungalow',
    mainImage: GrandLuvuOneBr,
    price: 6500000,
    location: 'Masaka, Nassarawa',
    mortgageAvailable: 'True',
    description: [
      'Grand Luvu Estate is a premium residential community in Masaka, Nasarawa State, offering 1-bedroom and 2-bedroom expandable homes in semi-detached and fully detached designs.',
      'Just minutes from Abuja, the estate provides a secure, serene, and well-planned environment with 24/7 security, paved roads, and green spaces.',
      'Homes are available in carcass for customization or semi-finished for a move-in-ready experience, making it ideal for both homeowners and investors.',
      'Limited units available—contact us today to secure your home!',
    ],
    otherImages: [],
  },
];

export default properties;
